module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA),
      expression: "tabA"
    }]
  }, [_c('div', {
    staticClass: "cont-head",
    class: {
      'newStyle': !_vm.newStyle, 'DE1': _vm.isDe || _vm.isPo || _vm.isIt || _vm.isSw || _vm.isCz
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('applyHcp')))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "icon-bor"
  }, [_c('select', {
    attrs: {
      "id": "chooseCountry"
    },
    on: {
      "change": _vm.select
    }
  }, [_c('option', {
    attrs: {
      "value": "GB"
    }
  }, [_vm._v("United Kingdom (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AU"
    }
  }, [_vm._v("Australia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CN"
    }
  }, [_vm._v("中国 (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HKF"
    }
  }, [_vm._v("香港(中国) (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TH"
    }
  }, [_vm._v("Thailand (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Indonesia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MY"
    }
  }, [_vm._v("Malaysia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("India (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("France (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Deutschland (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DD"
    }
  }, [_vm._v("Deutschland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HU"
    }
  }, [_vm._v("Magyarország (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("Italia (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("Nederland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Nor"
    }
  }, [_vm._v("Norge (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PT"
    }
  }, [_vm._v("Portugal (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("España (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("Sverige (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TR"
    }
  }, [_vm._v("Turkey (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ro"
    }
  }, [_vm._v("Romania (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CZ"
    }
  }, [_vm._v("Czech republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SK"
    }
  }, [_vm._v("Slovenska republika (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LT"
    }
  }, [_vm._v("Lithuania (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PL"
    }
  }, [_vm._v("Polska (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DK"
    }
  }, [_vm._v("Danmark (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FI"
    }
  }, [_vm._v("Suomi (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CH"
    }
  }, [_vm._v("Switzerland (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA"
    }
  }, [_vm._v("Saudi  (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AE"
    }
  }, [_vm._v("United Arab (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QA"
    }
  }, [_vm._v("Qatar  (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "QW"
    }
  }, [_vm._v("Kuwait (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RH"
    }
  }, [_vm._v("Croatia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AT"
    }
  }, [_vm._v("Austria (mg/dL)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SI"
    }
  }, [_vm._v("Slovenia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EE"
    }
  }, [_vm._v("Estonia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LV"
    }
  }, [_vm._v("Latvia (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("Bosnia and Herzegovina (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BG"
    }
  }, [_vm._v("Bulgaria (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CL"
    }
  }, [_vm._v("Chile (mmol/L)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BE"
    }
  }, [_vm._v("Belgium (mg/L)")])])]), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isI, 'vuerify-invalid': _vm.isR
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disE,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip5')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.nam
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "focus": function($event) {
        _vm.check57(0)
      },
      "blur": function($event) {
        _vm.check57(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isJ, 'vuerify-invalid': _vm.isS
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disF,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip7')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.organization),
      expression: "organization"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.org
    },
    domProps: {
      "value": (_vm.organization)
    },
    on: {
      "focus": function($event) {
        _vm.check58(0)
      },
      "blur": function($event) {
        _vm.check58(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organization = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isD),
      expression: "isD"
    }],
    staticClass: "icon-bor",
    class: {
      'in': _vm.isF, 'vuerify-invalid': _vm.isO, 'It2': _vm.isIt
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disA,
      "placement": "top",
      "effect": "light",
      "offset": "-30"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip1-1')))]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.$t('errtip1-2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: {
      'DE2': _vm.isDe
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.ema
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "focus": function($event) {
        _vm.check54(0)
      },
      "blur": function($event) {
        _vm.check54(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-bor",
    class: {
      'in': _vm.isK, 'vuerify-invalid': _vm.isT
    }
  }, [_c('el-tooltip', {
    attrs: {
      "disabled": _vm.disB,
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    staticClass: "tooltip",
    slot: "content"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('errtip2')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    class: {
      'DE2': _vm.isDe
    },
    attrs: {
      "placeholder": _vm.phone
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "focus": function($event) {
        _vm.check59(0)
      },
      "blur": function($event) {
        _vm.check59(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "operate",
    class: [_vm.isA ? 'xSelect' : 'xnoSelect']
  }), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.register
    }
  }, [_c('button', {
    staticClass: "register",
    class: {
      'click': true, 'DE2': _vm.isDe
    },
    attrs: {
      "disabled": !_vm.isNext
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabB),
      expression: "tabB"
    }]
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEU),
      expression: "isEU"
    }]
  }, [_c('p', [_vm._v("We will only process your Healthcare data through Medtrum App/website with your consent.")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1()
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA2 ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1_2()
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEU),
      expression: "!isEU"
    }]
  }, [_c('p', [_vm._v("We will only process your Healthcare data through Medtrum App/website with your consent.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1()
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "check",
    class: [_vm.isA2 ? 'Select' : 'noSelect']
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": function($event) {
        _vm.check1_2()
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "send-apply",
    class: {
      'click': _vm.isAgree, 'newStyle1': !_vm.newStyle
    },
    attrs: {
      "disabled": !_vm.isAgree
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v(_vm._s(_vm.$t('send')))]), _vm._v(" "), _c('span', {
    staticClass: "back-link"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.registerBack()
      }
    }
  }, [_vm._v("Back")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA1),
      expression: "tabA1"
    }],
    staticClass: "tabA1"
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('hcp_apply_user_exist'))
    }
  }, [_vm._v("This email address has been used by a patient/caregiver account. If you want to switch to an HCP account, choose Next.\n          ")]), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "next_step",
    on: {
      "click": _vm.nextStepA1
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "back"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.prevStepA1
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA2),
      expression: "tabA2"
    }],
    staticClass: "tabA2"
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Enter veri')))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    attrs: {
      "id": "check_email_for_code"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('check_email_for_code'))
    }
  }), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "try_again",
    class: {
      'try_enable': _vm.try_enable
    },
    on: {
      "click": _vm.tryAgainProc
    }
  }, [_vm._v(_vm._s(_vm.$t('try_again')) + " " + _vm._s(this.try_timer_text))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "veri_code icon-spe2",
    class: {
      'veri_focus': _vm.veri_focus
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.veri_code),
      expression: "veri_code"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.veri_placeholder
    },
    domProps: {
      "value": (_vm.veri_code)
    },
    on: {
      "focus": function($event) {
        _vm.checkVeriCode()
      },
      "blur": function($event) {
        _vm.checkVeriCode()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veri_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "next_step",
    on: {
      "click": _vm.nextStepA2
    }
  }, [_vm._v(_vm._s(_vm.$t('Next')))]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.prevStepA2
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])]), _vm._v(" "), (false) ? _c('div', [_c('p', {
    staticClass: "back"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.prevStepA2
    }
  }, [_vm._v(_vm._s(_vm.$t('Back')))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabA3),
      expression: "tabA3"
    }],
    staticClass: "tabA3"
  }, [_c('div', {
    staticClass: "policy-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Completed')))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('application_has_been_submitted')))]), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "bottom_btn"
  }, [_c('button', {
    staticClass: "next_step",
    on: {
      "click": _vm.signInNow
    }
  }, [_vm._v(_vm._s(_vm.$t('OK')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/doctor.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.co.uk/terms_of_use.html",
      "target": "_blank"
    }
  }, [_vm._v("the Terms of Use of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.co.uk/privacy_policy.html",
      "target": "_blank"
    }
  }, [_vm._v("the Privacy Policy of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.co.uk/terms_of_use.html",
      "target": "_blank"
    }
  }, [_vm._v("the Terms of Use of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("I Agree to "), _c('a', {
    attrs: {
      "href": "http://www.medtrum.com/privacy_policy.html",
      "target": "_blank"
    }
  }, [_vm._v("the Privacy Policy of Medtrum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Verfication Code.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/Verfication Code.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bc5e292"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hcpSign.vue
// module id = 1463
// module chunks = 7